import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';
import {fetchDomainUrl} from "./fetchDomain";

/**
 * 区县端
 * 新建页
 * 新建通知
 * @param {object} params
 */
export async function publish(params) {
  const API = await fetchDomainUrl();
  return request(`${API}/questionnaire/publish?${stringify(params)}`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

/**
 * 新建通知
 * 获取可关联问卷列表
 * 老师端
 * 提供者： 蒋东明
 */
export function fetchQuestionnaire(payload) {
  return request(`${url.noticeApi}/inform/list/questionnaire?${stringify(payload)}`);
}

/**
 * 新建数据填报
 * 保存
 * 提供者： 蒋东明
 * @params id: 填报的id
 */
export async function saveDraft(params) {
  const API = await fetchDomainUrl();
  return request(`${API}/questionnaire/save`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

/**
 * 新建数据填报
 * 预览
 * 提供者： 蒋东明
 * @params id: 填报的id
 */
export async function fetchPreview(params) {
  const API = await fetchDomainUrl();
  return request(`${API}/questionnaire/preview`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

